import { Subject } from 'rxjs';

export class TaxNoticeUpdateService {

    private _taxNotice = new Subject<any>();
    private _processTaxNotice = new Subject<any>();

    refreshTaxNotice(event) {
        this._taxNotice.next(event);
    }

    get taxNoticeRefreshEvents$() {
        return this._taxNotice.asObservable();
    }

    refreshProcessTaxNotice(event) {
        this._processTaxNotice.next(event);
    }

    get processTaxNoticeRefreshEvents$() {
        return this._processTaxNotice.asObservable();

    }
}
